import { css } from 'astroturf';
import React, { useEffect, useState } from 'react';
const styles = css`
  .introOuter {
    background: linear-gradient(145deg, #012b, #0126, #012b);
    padding: 0.6rem;
    max-width: min(1440px, 100vw - 1rem);
    border-radius: 1rem;
    box-shadow:
      rgba(255, 255, 255, 0.25) 0px 1px 1px 0px inset,
      rgba(50, 50, 93, 0.6) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.7) 0px 30px 60px -30px,
      rgba(103, 178, 111, 0.6) -10px 10px 60px -10px;

    @media (min-width: 59em) {
      margin: 3rem 2rem 0 !important;
    }
  }
  .introInner {
    display: flex;
    align-items: center;
    gap: 1rem;
    background: repeating-conic-gradient(#0004 0 0.0001%, #0000 0 0.0002%), #0128;
    background: #0128;
    color: #fff;
    padding: 1.5rem;
    border-radius: 0.6rem;
    box-shadow:
      rgba(255, 255, 255, 0.6) 0px 1px 1px 0px inset,
      rgba(50, 50, 93, 0.7) 0px 5px 10px;
    font-size: 1.1rem;
    text-wrap: balance;
  }

  .icon {
    display: none;

    @media (min-width: 59em) {
      flex: 0 0 96px;
      width: 96px;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 0.33rem;

      &.isMac {
        padding: 0;
      }
      img {
        border: 0;
        margin: 0;
        padding: 0;
      }
    }
  }
  .text {
    flex: 1 1 auto;
    line-height: 1.6;
  }
`;

const macIcon = '/img/brand/polypane-icon-mac-small.png';
const defaultIcon = '/img/brand/polypane-icon.svg';

const introText = (
  <>
    <strong>
      What&apos;s <a href="/">Polypane</a>?
    </strong>{' '}
    Polypane is your workspace for building great websites. A Chromium-based desktop app with multiple synced viewports,
    comprehensive device emulation, and instant feedback on accessibility, structure, and performance.{' '}
    <b>Built for developers who care about their craft.</b>
  </>
);

function PolypaneIntro() {
  const [isMac, setIsMac] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMac(/Mac|iPhone|iPad|iPod/.test(window.navigator.platform));
    }
  }, []);

  return (
    <div className={styles.introOuter}>
      <div className={styles.introInner}>
        <span className={[styles.icon, isMac ? styles.mac : ''].join(' ')}>
          <img src={isMac ? macIcon : defaultIcon} alt="Polypane icon" />
        </span>
        <span className={styles.text}>{introText}</span>
      </div>
    </div>
  );
}

export default PolypaneIntro;
